/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import {
  useEffect, useState, useRef, useContext,
} from 'react';
import PropTypes from 'prop-types';

import cloneDeep from 'lodash.clonedeep';

// components
import { useTheme } from 'styled-components';
import compare from '../../utils/functions/sorting';
import Loader from '../../juristec-ui/core/Loader';
// import InstanceTable from '../../juristec-ui/core/InstanceTable';
import AdminToolbar from '../../components/Toolbars/AdminToolbar';
import InstanceUsersTable from '../../components/Modals/InstanceUsersTable';
// import NewInstance from '../../components/ProgressiveModals/NewInstance';
import AddUser from '../../components/Modals/AddUser';
import AddAntecipei from '../../components/Modals/AddAntecipei';
import OnboardingReport from '../../components/ProgressiveModals/OnboardingReport';
import TransferUser from '../../components/Modals/TransferUser';
import ChangeUserRole from '../../components/Modals/ChangeUserRole';
import SessionManager from '../../components/Modals/SessionManager';
import ChangeReportOwner from '../../components/Modals/ChangeReportOwner';
import ReportColumns from '../../components/Modals/ReportColumns';
import ReportsTable from '../../components/ReportsTable';
import InstanceTable from '../../components/InstanceTable';
import FileReport from '../../components/FilesView/FileReport';
import FileReportInactive from '../../components/FilesView/FileReportInactive';
import AddBenner from '../../components/Modals/AddBenner/AddBenner';
import InstanceMessage from '../../components/Modals/InstanceMessage';
import MultiMessages from '../../components/Modals/MultiMessages';
import CustomColumns from '../../components/Modals/CustomColumns';
import {
  FormulaCustomColumns, MapCustomColumns,
} from '../../components/ProgressiveModals/ManageCustomColumns';
import UserInfo from '../../components/Modals/UserInfo';
import UsersTable from '../../components/UsersTable/UsersTable';
import AddTokens from '../../components/Modals/AddTokens';
import UserHistory from '../../components/Modals/UserHistory/UserHistory';
import GenEmptyFile, { CopyHash } from '../../components/Modals/GenEmptyFile';
import ReportETLs from '../../components/Modals/ReportETLs';
import CopyText from '../../juristec-ui/core/CopyText';
import RegisterTrainingDate from '../../components/Modals/RegisterTrainingDate';
import ManageInstance from '../../components/Modals/ManageInstance/ManageInstance';
import useDeviceType from '../../juristec-ui/hooks/useDeviceType';
import UserDashboards from '../../components/Modals/UserDashboards/UserDashboards';
import DashSharedWith from '../../components/Modals/DashSharedWith/DashSharedWith';
import DashboardDependencies from '../../components/Modals/DashboardDependencies';
import DashboardKpisList from '../../components/Modals/DashboardKpisList/DashboardKpisList';
import RegisterApiGedCredentials from '../../components/Modals/RegisterApiGedCredentials/RegisterApiGedCredentials';
import DeactivateUser from '../../components/Modals/DeactivateUser';
import ChangeDatabasePassword from '../../components/Modals/ChangeDatabasePassword';
import AllowL1ReportsBySupport from '../../components/Modals/AllowL1ReportsBySupport';
import AdminUserEmail from '../../components/Modals/AdminUserEmail';
import ListKpisDependenciesFromColumns from '../../components/ListKpisDependenciesFromColumns';

// providers an other
import InstanceProvider, { InstanceContext } from '../../context/InstanceProvider';
import { AlertContext } from '../../context/AlertProvider';
import { FilesContext } from '../../context/FilesProvider';
import { ModalContext } from '../../context/ModalProvider';
import { AuthContext } from '../../context/AuthProvider';
import { verifyFileSheetType } from '../../juristec-ui/utils/validators/fileValidators';
import { getOriginOptionsSupport, getConnectorOptionsSupport } from '../../juristec-ui/utils/originMap';
import InstanceDetails from '../../components/Modals/InstanceDetails';

const ROLES = {
  SUPPORT: 'support',
  SCIENTIST: 'scientist',
  GUEST: 'guest',
  SUPER: 'super',
};
const ROLESMAP = {
  support: 'suporte',
  super: 'proprietários',
  scientist: 'cientistas',
  guest: 'convidados',
};
const ROLEORDER = ['super', 'scientist', 'guest'];

function AdminPage() {
  const [filterText, setFilterText] = useState('');
  const [tab, setTab] = useState('customers');
  const theme = useTheme();
  const { state: instanceState, instanceAPI } = useContext(InstanceContext);
  const { user, claimsUser, plans } = useContext(AuthContext);
  const { setAlertConfig, toggleAlert } = useContext(AlertContext);
  const { filesAPI } = useContext(FilesContext);
  const { setModalConfig, toggleModal, closeModal } = useContext(ModalContext);

  const isMounted = useRef(false);
  const cronRef = useRef(null);

  const device = useDeviceType();

  const handleText = (e) => {
    const { value } = e.target;
    clearTimeout(cronRef.current);
    cronRef.current = setTimeout(() => {
      setFilterText(value.trim());
    }, 200);
  };

  useEffect(() => {
    setFilterText('');
  }, [tab]);

  const handleGetUsers = async () => {
    const res = await instanceAPI.getUsers();
    if (res.error) {
      setAlertConfig({
        type: 'error',
        text: res.msg,
        child: res.raw,
      });
      return null;
    }
    return res.users;
  };

  // USUÁRIOS DA INSTÂNCIA
  const handleGetInstanceUser = async (instance) => {
    let users = [];
    if (!instance.users) {
      const res = await instanceAPI.getInstanceUsers(instance.id);
      if (res.error) {
        setAlertConfig({
          type: 'error',
          text: res.msg,
        });
        return null;
      }
      users = res.users;
    } else {
      users = instance.users;
    }
    return users;
  };

  const checkLimits = (instance, count, role, oldRole) => {
    const auxCount = { ...count };
    auxCount[role] += 1;
    if (oldRole) auxCount[oldRole] -= 1;
    if ((auxCount.super ?? 0) === 0) {
      setAlertConfig({
        type: 'error',
        text: 'Instância deve ter no mínimo 1 proprietário',
      });
      return false;
    }
    let used = 0;
    let capacity = 0;
    let errorMsg = '';
    ROLEORDER.forEach((r) => {
      used += auxCount[r];
      capacity += (instance[`${r}s`] ?? instance[`${r}S`] ?? 0);
      if (used > capacity) errorMsg = `Limite máximo de usuários ${ROLESMAP[r]} atingido nesta instância`;
    });
    if (errorMsg.length > 0) setAlertConfig({ type: 'error', text: errorMsg });
    return errorMsg.length === 0;
  };

  /**
   * Transfers all allowed data from one user to another
   * @param {array} usersValids List of allowed users to receive the transfer
   * @param {object} selectedUser User information to be transferred
   * @param {object} instance User instance info
   */
  const handleTransferUser = async (usersValids, selectedUser, instance, viewerOnly) => {
    const options = usersValids.reduce((aux, u) => {
      if ((u.role === ROLES.SUPER || u.role === ROLES.SCIENTIST) && u.uid !== selectedUser.uid) {
        aux.push({ label: u.name, value: u.uid, id: `transfer-${u.uid}` });
      }
      return aux;
    }, []).sort((a, b) => (compare(a.label, b.label)));

    const hideModal = () => toggleModal('transfer-user');

    /** Submit the transfer request */
    const submitTransfer = async (userToReceive) => {
      const res = await instanceAPI.transferUserData(
        instance.id, selectedUser.uid, userToReceive.value, viewerOnly,
      );
      if (res.error) {
        setAlertConfig({
          type: 'error',
          text: res.msg,
          child: res.raw,
        });
        return;
      }
      setAlertConfig({
        type: 'success',
        text: 'Usuário transferido com sucesso!',
        child: `Arquivos e dashboards do usuário ${selectedUser.name} foram transferidos para o usuário ${userToReceive.label}`,
      });
      hideModal();
    };

    setModalConfig({
      title: viewerOnly ? 'Verificar arquivos e dashboards' : 'Transferir arquivos e dashboards',
      nodeTarget: 'transfer-user',
      children: (
        <TransferUser
          selectedUser={selectedUser}
          usersOptions={options}
          close={hideModal}
          submit={submitTransfer}
          viewerOnly={viewerOnly}
        />
      ),
    });
  };

  const fetchReports = (page, filters, qty, reset = false, dontSetState = false) => {
    const auxFilters = cloneDeep(filters ?? {});
    if (!claimsUser?.is_admin) {
      if (!auxFilters?.origin?.selected?.length > 0) {
        auxFilters.origin = {
          selected: getOriginOptionsSupport.map((opt) => opt.value),
        };
      }
      if (!auxFilters?.connector?.selected?.length > 0) {
        auxFilters.connector = {
          selected: getConnectorOptionsSupport.map((opt) => opt.value),
        };
      }
    }
    return instanceAPI.getReports(page, auxFilters, qty, reset, dontSetState);
  };

  const handleGenEmptyFile = async (selectedUser, instance, type) => {
    const hideModal = () => toggleModal('empty-ged');

    const submitGen = async (filename) => {
      const res = await instanceAPI.genEmptyFile(
        filename,
        instance.id,
        selectedUser.uid,
        type === 'ged' ? 'l1reportsapi' : 'mail',
        type === 'ged' ? 'LegalOne' : 'Mail',
      );
      if (res.error) {
        setAlertConfig({
          type: 'error',
          text: res.msg,
          child: res.raw,
        });
        return;
      }
      setAlertConfig({
        type: 'success',
        text: 'Relatório gerado com sucesso!',
        child: <CopyHash hash={res.hash} />,
      });
      fetchReports(0, {}, 25);
      hideModal();
    };

    setModalConfig({
      title: type === 'ged' ? 'Gerar relatório GED vazio' : 'Gerar relatório de e-mail vazio',
      nodeTarget: 'empty-ged',
      children: (
        <GenEmptyFile
          close={hideModal}
          submit={submitGen}
        />
      ),
    });
  };

  /**
   * @async Allows the admin to change the roles of any user on any instance
   * @param {array} users array of users in an instance
   * @param {object} selectedUser user data to be changed
   * @param {object} instance selected users instance
   */
  const handleChangePermission = async (users, selectedUser, instance) => {
    const usersQtd = { super: 0, scientist: 0, guest: 0 };

    /**
     * @type {array} Counts and filters users based on their roles,
     * and creates a array of option
     */
    const validScientists = users.reduce((aux, u) => {
      if (u.role !== 'guest') {
        if (u.role === 'super') usersQtd.super += 1;
        else usersQtd.scientist += 1;
        if (u.uid !== selectedUser.uid) aux.push({ id: u.uid, label: u.name, value: u.uid });
      } else usersQtd.guest += 1;
      return aux;
    }, []);

    const hideModal = () => toggleModal('change-role');

    /**
     * @async Send the request with the modified user data
     * @param {string} newRole the user new role
     * @param {string} scientistKey the user new responsible scientist.
     * Only used when his role is 'guest'
     */
    const handleSubmitRole = async (newRole, scientistKey) => {
      if (!checkLimits(instance, usersQtd, newRole, selectedUser.role)) return;
      const res = await instanceAPI.newEditUser(
        selectedUser.uid, { role: newRole, scientist: scientistKey },
      );
      // const res = await instanceAPI.changeUserRoleByAdmin(
      //   instance.id, scientistKey, selectedUser.email, newRole,
      // );
      if (res.error) {
        setAlertConfig({
          type: 'error',
          text: res.msg,
          child: res.raw,
        });
        return;
      }
      setAlertConfig({
        type: 'success',
        text: `Permissão do usuário ${selectedUser.name} alterada com sucesso!`,
      });
      instanceAPI.getInstanceUsers(instance.id);
      hideModal();
      toggleModal();
    };

    setModalConfig({
      title: 'Alterar permissão',
      nodeTarget: 'change-role',
      children: (
        <ChangeUserRole
          selectedUser={selectedUser}
          scientists={validScientists}
          close={hideModal}
          submit={handleSubmitRole}
        />
      ),
    });
  };

  const handleBlockUser = (selectedUser) => {
    const handler = async (set) => {
      const res = await instanceAPI.newEditUser(
        selectedUser.uid, { disabled: !selectedUser.disabled },
      );
      // const res = await instanceAPI.blockUser(
      //   selectedUser.instanceId, selectedUser.scientist, selectedUser.email, selectedUser.disabled ? 'False' : 'True',
      // );
      if (res.error) {
        setAlertConfig({
          type: 'error',
          text: res.msg,
          child: res.raw,
        });
        // set(false);
        return;
      }

      setAlertConfig({
        type: 'success',
        text: `Usuário ${selectedUser.disabled ? 'desbloqueado' : 'bloqueado'} com sucesso!`,
      });
      set(!selectedUser.disabled);
    };

    const modalHandler = (f) => {
      setAlertConfig({
        type: 'warning',
        text: `Deseja ${selectedUser.disabled ? 'desbloquear' : 'bloquear'} usuário?`,
        child: selectedUser.disabled
          ? `O usuário ${selectedUser.email} voltará a acessar o sistema!`
          : `O usuário ${selectedUser.email} não poderá acessar o sistema!`,
        withoutConfirm: true,
        withFunction: true,
        confirmFunction: f,
      });
    };

    return { modalHandler, handler };
  };

  const handleDeactivateUser = (selectedUser) => {
    const companyId = selectedUser?.instanceId || selectedUser?.company?.id;

    const instance = instanceState.instances.find((i) => i.id === companyId);
    const instanceUsers = instanceState?.users.filter((u) => u?.company?.id === companyId);
    const submitDelete = async (transferToEmail) => {
      const res = await instanceAPI.deactivateUser(companyId, selectedUser?.email, transferToEmail);
      if (res?.error) {
        setAlertConfig({
          type: 'error',
          text: res?.msg,
          child: res?.raw,
        });
        return;
      }
      setAlertConfig({
        type: 'success',
        text: `Usuário ${selectedUser?.email} apagado com sucesso!`,
      });
    };

    setModalConfig({
      title: 'Remover usuário',
      children: (
        <DeactivateUser
          user={selectedUser}
          instanceUsers={instanceUsers}
          instance={instance}
          handleGetInstanceUsers={handleGetInstanceUser}
          theme={theme}
          submit={submitDelete}
          hide={closeModal}
        />
      ),
    });
  };

  const handleReactivateUser = (selectedUser) => {
    const handler = async (set) => {
      const res = await instanceAPI.reactivateUser(selectedUser.email, selectedUser.instanceId);
      if (res?.error) {
        setAlertConfig({
          type: 'error',
          text: res?.msg,
          child: res?.raw,
        });
      }
      setAlertConfig({
        type: 'success',
        text: `Usuário ${selectedUser?.email} restaurado com sucesso!`,
      });
      set(!selectedUser.removed);
    };

    const modalHandler = (f) => {
      setAlertConfig({
        type: 'warning',
        text: `Tem certeza que deseja restaurar o usuário ${selectedUser.email}?`,
        child: `O usuário ${selectedUser.email} voltará a acessar o sistema!`,
        withoutConfirm: true,
        withFunction: true,
        confirmFunction: f,
      });
    };

    return { handler, modalHandler };
  };

  const handleDeleteUser = (selectedUser) => {
    const handler = async (set) => {
      const res = await instanceAPI.deleteUser(selectedUser.instanceId, selectedUser.email);
      if (res?.error) {
        setAlertConfig({
          type: 'error',
          text: res?.msg,
          child: res?.raw,
        });
      }
      setAlertConfig({
        type: 'success',
        text: `Usuário ${selectedUser?.email} apagado com sucesso!`,
      });
      set();
    };

    const modalHandler = (f) => {
      setAlertConfig({
        type: 'warning',
        text: `Tem certeza que deseja apagar o usuário ${selectedUser.email}?`,
        child: `O usuário ${selectedUser.email} será removido completamente do sistema!`,
        withoutConfirm: true,
        withFunction: true,
        confirmFunction: f,
      });
    };

    return { handler, modalHandler };
  };

  const handleGetResetPwdLink = async (selectedUser) => {
    const res = await instanceAPI.resetPwdLink(selectedUser.email, selectedUser.instanceId);
    if (res.error) {
      setAlertConfig({
        type: 'error',
        text: res.msg,
        child: res.raw,
      });
      return;
    }
    setAlertConfig({
      type: 'success',
      text: 'Link de redefinição de senha gerado',
      child: <CopyText text={res.link} />,
    });
  };

  const handleUserEmail = (selectedUser) => {
    const submitNewEmail = async (newEmail, set) => {
      const res = await instanceAPI.changeUserEmail(selectedUser.user_id, newEmail);
      if (res.error) {
        setAlertConfig({
          type: 'error',
          text: res.msg,
          child: res.raw,
        });
        return;
      }
      closeModal();
      setAlertConfig({
        type: 'success',
        text: 'Troca de e-mail realizada com sucesso!',
        child: `Novo e-mail: ${newEmail}`,
      });
      set(newEmail);
    };

    const sendEmailVerification = async () => {
      const res = await instanceAPI.sendVerificationEmail(selectedUser.user_id);
      if (res.error) {
        setAlertConfig({
          type: 'error',
          text: res.msg,
          child: res.raw,
        });
        return;
      }
      setAlertConfig({
        type: 'success',
        text: 'E-mail de verificação enviado!',
        child: `Verifique o recebimento em: ${selectedUser.email}. Não esqueça de olhar a caixa de spam!`,
      });
    };

    const modalHandler = (handler) => {
      setModalConfig({
        title: 'Gerenciar e-mail',
        children: (
          <AdminUserEmail
            email={selectedUser.email}
            hide={closeModal}
            sendEmailVerification={sendEmailVerification}
            submitNewEmail={handler}
          />
        ),
      });
    };

    return { submitNewEmail, modalHandler };
  };

  const handleSessionManager = async (selectedUser, setData) => {
    const hideModal = () => toggleModal('session-manager');
    const handleSubmitSessionManager = async (value) => {
      const res = await instanceAPI.newEditUser(
        selectedUser.uid, { sessionTimeout: value },
      );
      // const res = await instanceAPI.sessionTimeoutUser(
      //   selectedUser.instanceId, selectedUser.scientist, selectedUser.email, value,
      // );
      if (res?.error) {
        setAlertConfig({
          type: 'error',
          text: res?.msg,
          child: res?.raw,
        });
      } else {
        setAlertConfig({
          type: 'success',
          text: `Tempo sessão do usuário ${selectedUser?.email} alterado com sucesso!`,
        });
        setData((p) => (
          p.map((u) => (
            u.uid === selectedUser.uid ? { ...u, sessionTimeout: value } : u
          ))
        ));
        hideModal();
      }
    };
    setModalConfig({
      title: 'Tempo de sessão',
      nodeTarget: 'session-manager',
      children: (
        <SessionManager
          sessionTimeout={selectedUser.sessionTimeout}
          close={hideModal}
          submit={handleSubmitSessionManager}
        />
      ),
    });
  };

  const handleMultiSession = async (selectedUser, value) => {
    const res = await instanceAPI.newEditUser(
      selectedUser.uid, { multiSessions: value === 'True' },
    );
    // const res = await instanceAPI.multiSessionUser(
    //   selectedUser.instanceId, selectedUser.scientist, selectedUser.email, value,
    // );
    if (res?.error) {
      setAlertConfig({
        type: 'error',
        text: res?.msg,
        child: res?.raw,
      });
    } else {
      setAlertConfig({
        type: 'success',
        text: `Sessão simulânea do usuário ${selectedUser?.email} ${value === 'True' ? 'liberada' : 'bloqueada'} com sucesso!`,
      });
    }
  };

  const openUsersModal = async (instance) => {
    const users = await handleGetInstanceUser(instance);
    if (!users) return;

    const transferModal = (selected) => { handleTransferUser(users, selected, instance, false); };
    const handlePermission = (selected) => handleChangePermission(users, selected, instance);
    const handleCopyDashboards = (selected) => handleTransferUser(users, selected, instance, true);
    const genEmptyFileModal = (selected, type) => handleGenEmptyFile(selected, instance, type);
    const handleRegisterTrainingDate = (selectedUser, setData) => {
      const hideTrainingDate = () => toggleModal('user-training-date');
      // const companyId = selectedUser?.instanceId || selectedUser?.company?.id;
      const submit = async (trainingDate) => {
        const res = await instanceAPI.newEditUser(
          selectedUser.uid, { trainedAt: trainingDate },
        );
        // const res = await instanceAPI.registerTrainingDate(
        //   companyId, selectedUser?.email, trainingDate,
        // );
        if (res?.error) {
          setAlertConfig({
            type: 'error',
            text: res?.msg,
            child: res?.raw,
          });
          return;
        }
        setAlertConfig({
          type: 'success',
          text: `Data de treinamento atualizada com sucesso para o usuário "${selectedUser?.email}"!`,
        });
        setData((p) => (
          p.map((u) => (
            u.uid === selectedUser.uid ? { ...u, trainedAt: trainingDate.toISOString() } : u
          ))
        ));
      };

      setModalConfig({
        title: 'Cadastrar data de treinamento',
        nodeTarget: 'user-training-date',
        children: (
          <RegisterTrainingDate
            user={selectedUser}
            submit={submit}
            hide={hideTrainingDate}
          />
        ),
      });
    };

    setModalConfig({
      title: 'Usuários',
      children: (
        <InstanceUsersTable
          users={users}
          hasLoginProvider={(instance?.loginProvider?.length ?? 0) > 0}
          handleTransfer={transferModal}
          handleBlock={handleBlockUser}
          handleDelete={handleDeleteUser}
          handleDeactivate={handleDeactivateUser}
          handleReactivateUser={handleReactivateUser}
          handlePermission={handlePermission}
          handleCopyDashboards={handleCopyDashboards}
          handleSessionManager={handleSessionManager}
          handleMultiSession={handleMultiSession}
          handleGenEmptyFile={genEmptyFileModal}
          userIsAdmin={claimsUser?.is_admin}
          handleRegisterTrainingDate={handleRegisterTrainingDate}
        />
      ),
    });
  };

  const handleInformation = async (instance) => {
    const instanceInfo = instanceState.instances.find((i) => i.id === instance.id);

    setModalConfig({
      title: 'Informações da Instância',
      children: (
        <InstanceDetails
          instanceInfo={instanceInfo}
        />
      ),
    });
  };

  // INSTÂNCIA
  const handleNewInstance = async () => {
    const handleSubmit = async (instanceConfigs, emailsSuper, emailsScientist, image) => {
      const res = await instanceAPI.createInstance(
        instanceConfigs, emailsSuper, emailsScientist, image,
      );
      if (res.error) {
        setAlertConfig({
          type: 'error',
          text: res.msg,
          child: res.raw,
        });
        return;
      }

      setAlertConfig({
        type: 'success',
        text: `Instância ${instanceConfigs.name} criada com sucesso!`,
      });
      closeModal();
      instanceAPI.getInstances();
    };

    const genPlansOpts = () => (
      Object.entries(plans).reduce((aux, [key, val]) => {
        aux[key] = { ...val, value: key, id: key };
        return aux;
      }, {})
    );

    setModalConfig({
      title: 'Nova Instância',
      disableFocus: true,
      // children: (
      //   <NewInstance
      //     closeModal={closeModal}
      //     submitNewInstance={handleSubmit}
      //     plans={plans}
      //   />
      // ),
      children: (
        <ManageInstance
          close={closeModal}
          plans={genPlansOpts()}
          submit={handleSubmit}
        />
      ),
    });
  };

  const handleEditInstance = async (instance) => {
    const handleSubmit = async (instanceConfigs) => {
      const res = await instanceAPI.editInstance(instanceConfigs);
      if (res.error) {
        setAlertConfig({
          type: 'error',
          text: res.msg,
          child: res.raw,
        });
        return;
      }

      setAlertConfig({
        type: 'success',
        text: `Instância ${instanceConfigs.name} editado com sucesso!`,
      });
      closeModal();
      instanceAPI.getInstances();
    };

    const genPlansOpts = () => (
      Object.entries(plans).reduce((aux, [key, val]) => {
        aux[key] = { ...val, value: key, id: key };
        return aux;
      }, {})
    );

    setModalConfig({
      title: 'Editar Instância',
      disableFocus: true,
      // children: (
      //   <NewInstance
      //     isEdit
      //     toEditInstance={instance}
      //     submitEditInstance={handleSubmit}
      //     closeModal={closeModal}
      //     plans={plans}
      //   />
      // ),
      children: (
        <ManageInstance
          close={closeModal}
          plans={genPlansOpts()}
          editData={{
            ...instance,
            operationalDate: instance.operationalDate ?? '1900-01-01T03:06:28.000+00:00',
            signatureDate: instance.signatureDate ?? '1900-01-01T03:06:28.000+00:00',
            supers: instance.superS ?? undefined,
          }}
          submit={handleSubmit}
        />
      ),
    });
  };

  const handleAddTokens = async (instance) => {
    const handleSubmit = async (tokens) => {
      const res = await instanceAPI.addBonusTokens(
        instance.id, tokens, user.email,
      );
      if (res.error) {
        setAlertConfig({
          type: 'error',
          text: res.msg,
          child: res.raw,
        });
        return;
      }
      const s = tokens > 1 ? 's' : '';
      setAlertConfig({
        type: 'success',
        text: `${tokens} Token${s} adicionado${s} com sucesso!`,
      });
      closeModal();
    };

    const getTokensInfo = async () => {
      const limit = instance.gptTokens ?? 100;
      const res = await instanceAPI.getInstanceTokens(instance.id);
      if (res.error) {
        setAlertConfig({
          type: 'error',
          text: res.msg,
          child: res.raw,
        });
        return { limit, used: 0, bonus: 0 };
      }
      return { limit, used: res.used, bonus: res.bonus };
    };

    setModalConfig({
      title: 'Tokens Cortesia',
      disableFocus: true,
      children: (
        <AddTokens
          close={closeModal}
          getTokensInfo={getTokensInfo}
          submit={handleSubmit}
        />
      ),
    });
  };

  const handleBlockInstance = async (instance) => {
    const handleBlock = async () => {
      const res = await instanceAPI.blockInstance(instance.id, !instance.disabled);
      if (res.error) {
        setAlertConfig({
          type: 'error',
          text: res.msg,
          child: res.raw,
        });
        return;
      }

      setAlertConfig({
        type: 'success',
        text: `${instance.disabled ? 'Desbloqueado' : 'Bloqueado'} com sucesso!`,
      });
    };

    setAlertConfig({
      type: 'warning',
      text: `${instance.disabled ? 'Desbloquear' : 'Bloquear'} instância ${instance.name}?`,
      withoutConfirm: true,
      withFunction: true,
      confirmFunction: handleBlock,
    });
  };

  const handleDeleteInstance = async (instance) => {
    const handleDelete = async () => {
      const res = await instanceAPI.deleteInstance(instance.id);
      if (res.error) {
        setAlertConfig({
          type: 'error',
          text: res.msg,
          child: res.raw,
        });
        return;
      }

      setAlertConfig({
        type: 'success',
        text: `Instância ${instance.name} apagada com sucesso!`,
      });
    };

    setAlertConfig({
      type: 'warning',
      text: `Apagar a instância ${instance.name}?`,
      withoutConfirm: true,
      withFunction: true,
      confirmFunction: handleDelete,
    });
  };

  const handleMessageInstance = async (instance) => {
    let users = await handleGetInstanceUser(instance);
    if (!users) return;
    users = users.reduce((aux, u) => {
      switch (u.role) {
        case ROLES.SUPER:
          aux.supers.push(u);
          break;
        case ROLES.SCIENTIST:
          aux.scientists.push(u);
          break;
        default:
          aux.guests.push(u);
          break;
      }
      return aux;
    }, { supers: [], scientists: [], guests: [] });

    const handleSubmit = async (lvl, title, showUntil, link, sUsers, message) => {
      const res = instanceAPI.sendUsersMessage(
        instance.id, lvl, title, showUntil, link, sUsers, message,
      );
      if (res.error) {
        setAlertConfig({
          type: 'error',
          text: res.msg,
          child: res.raw,
        });
        return;
      }
      setAlertConfig({
        type: 'success',
        text: 'Mensagem enviada aos usuários selecionados!',
      });
      closeModal();
    };

    if (users.supers.length > 0 || users.scientists.length > 0 || users.guests.length > 0) {
      setModalConfig({
        title: 'Nova Mensagem',
        disableFocus: true,
        children: (
          <InstanceMessage
            hide={closeModal}
            users={users}
            submit={handleSubmit}
          />
        ),
      });
    } else {
      setAlertConfig({
        type: 'warning',
        text: 'Sem usuários na instância!',
      });
    }
  };

  /**
   * Handles removal of a report
   * @param {object} report report info
   */
  const handleDeleteReport = async (report, fetchUpdate) => {
    const handleDelete = async () => {
      const res = await instanceAPI.deleteReport(report.id);
      if (res.error) {
        setAlertConfig({
          type: 'error',
          text: res.msg,
          child: res.raw,
        });
        return;
      }
      setAlertConfig({
        type: 'success',
        text: `Relatório ${report.filename} apagado com sucesso!`,
      });
      fetchUpdate();
    };

    setAlertConfig({
      type: 'warning',
      text: `Tem certeza que deseja apagar o relatório ${report.filename}?`,
      withoutConfirm: true,
      withFunction: true,
      confirmFunction: handleDelete,
    });
  };
  /**
   * Handles removal of a report
   * @param {object} report report info
   */
  const handleResetReport = async (report, fetchUpdate) => {
    const handleReset = async () => {
      const res = await instanceAPI.resetReport(report.id);
      if (res.error) {
        setAlertConfig({
          type: 'error',
          text: res.msg,
          child: res.raw,
        });
        return;
      }
      setAlertConfig({
        type: 'success',
        text: `Relatório ${report.filename} resetado com sucesso, atualize a base!`,
      });
      fetchUpdate();
    };

    setAlertConfig({
      type: 'warning',
      text: `Tem certeza que deseja resetar o relatório ${report.filename}? A base será substituída por uma base vazia.`,
      withoutConfirm: true,
      withFunction: true,
      confirmFunction: handleReset,
    });
  };

  const handleChangeReportOwner = async (report, fetchUpdate) => {
    let users = [];
    if (report.companyId) {
      const res = await instanceAPI.getInstanceUsers(report.companyId);
      if (res.error) {
        setAlertConfig({
          type: 'error',
          text: res.msg,
        });
      } else {
        users = res.users;
      }
    }

    const getOwner = (id) => {
      const currentOwner = users.find((u) => u.uid === id);
      return currentOwner?.email || 'Não encontrado';
    };

    const usersOptions = [];
    users.forEach((u) => {
      if (u.role !== 'guest' && u.uid !== report.ownerId) {
        usersOptions.push({
          id: u.uid,
          label: u.email,
          value: u.email,
        });
      }
    });
    usersOptions.sort((a, b) => (compare(a.label, b.label)));

    const handleSubmit = async (newOwner, removeOldOwner = true) => {
      const res = await instanceAPI.changeOwnerReport(
        report?.companyId || '',
        report.id.split('_')[1] || '',
        report.ownerId,
        newOwner.id,
        removeOldOwner,
      );
      if (res.error) {
        setAlertConfig({
          type: 'error',
          text: res.msg,
          child: res.raw,
        });
        return;
      }

      setAlertConfig({
        type: 'success',
        text: 'Propriedade do relatório transferida com sucesso!',
        child: `A propriedade do relatório foi transferida para o usuário ${newOwner.label}!`,
      });
      fetchUpdate();
      closeModal();
    };

    setModalConfig({
      title: 'Alterar Proprietário',
      disableFocus: true,
      children: (
        <ChangeReportOwner
          currentOwner={report?.ownerEmail || report?.ownerId ? getOwner(report.ownerId) : 'Não encontrado'}
          usersOptions={usersOptions}
          submit={handleSubmit}
          close={closeModal}
        />
      ),
    });
  };

  /**
   * Opens an alert showing the report's update information
   * @param {object} report report info
   */
  const openReportStatus = async (report, fetchUpdate) => {
    /**
     * Updates a file manually
     * @param {object?} file File object (undefined for 'LegalOne' reports)
     */
    const handleUpdate = async (file) => {
      const generateErrorReport = async () => {
        const res = await instanceAPI.errorReport(report.id, report.origin, file, report.filename);
        if (res.error) {
          setAlertConfig({
            type: 'error',
            text: 'Houve um erro ao gerar o relatório de erros.',
            child: res.raw,
          });
          return;
        }
        const blob = res.res;
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', blob.filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        toggleAlert();
      };
      const GenerateReport = ({
        text = 'Houve um erro ao atualizar o relatório.',
        auditable = false,
      }) => (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span>{text}</span>
          {auditable && (
            <span>
              Se desejar extrair o relatório de auditoria,
              <div
                style={{
                  marginLeft: '5px', cursor: 'pointer', color: 'blue', textDecoration: 'underline', display: 'inline',
                }}
                onClick={generateErrorReport}
              >
                clique aqui
              </div>
            </span>
          )}
        </div>
      );
      const res = await instanceAPI.manualReportUpdate(
        report.id, report.origin, file, report.filename,
      );
      if (res.error) {
        setAlertConfig({
          type: res.type === 'warning' ? 'warning' : 'error',
          text: res.type === 'warning' ? `Relatório ${report.filename} atualizado!` : res.msg,
          child: <GenerateReport text={res.raw} auditable={res?.auditable} />,
        });
        return;
      }
      setAlertConfig({
        type: res.type,
        text: res.type === 'success'
          ? `Relatório ${report.filename} atualizado com sucesso!`
          : `Relatório ${report.filename} atualizado parcialmente!`,
        child: (res.type === 'warning' && res.data.errors && res.data.errors[0].substring(0, 3) === 'KPI')
          ? `${res.data.errors.length} KPI's não puderam ser atualizados. Houve algum erro na tentativa de construir esses KPI's!`
          : '',
      });
      fetchUpdate();
    };

    /**
     * Handles a file upload for the update
     * @param {object[]?} files File object (undefined for 'LegalOne' reports)
     */
    const updateFileUp = (files = []) => {
      if (report.origin === 'FileApi') {
        const errorMsg = verifyFileSheetType(files[0]);
        if (errorMsg.length > 0) {
          setAlertConfig({
            type: 'error',
            text: 'Erro na atualização!',
            child: errorMsg,
          });
          return;
        }
      }
      setAlertConfig({
        type: 'warning',
        text: `Atualizar o relatório ${report.filename} manualmente?`,
        withoutConfirm: true,
        withFunction: true,
        confirmFunction: () => handleUpdate(files[0]),
      });
    };

    /**
     * Handles inactivation of a report
     */
    const handleInactivate = async () => {
      const handleInactivateSubmit = async () => {
        const res = await instanceAPI.inactivateReport(report.id);
        if (res.error) {
          setAlertConfig({
            type: 'error',
            text: res.msg,
            child: res.raw,
          });
          return;
        }
        setAlertConfig({
          type: 'success',
          text: `Relatório ${report.filename} inativado com sucesso!`,
        });
        fetchUpdate();
      };
      setAlertConfig({
        type: 'warning',
        text: `Tem certeza que deseja inativar o relatório ${report.filename}?`,
        withoutConfirm: true,
        withFunction: true,
        confirmFunction: handleInactivateSubmit,
      });
    };

    const res = await instanceAPI.getReportStatus(report.id);
    if (res.error) {
      setAlertConfig({
        type: 'error',
        text: res.msg,
        child: res.raw,
      });
      return;
    }

    const infoReport = {
      ...res.data,
    };

    let status = '';
    let msg = '';
    if (infoReport.lastAttemptStatus === 'ERROR') {
      status = 'error';
      msg = 'Erro ao atualizar o relatório!';
    } else if (infoReport.lastAttemptStatus === 'WARNING') {
      status = 'warning';
      msg = 'Relatório atualizado!';
    } else {
      status = 'success';
      msg = 'Relatório atualizado com sucesso!';
    }
    setAlertConfig({
      type: status,
      text: msg,
      child: <FileReport
        file={infoReport}
        manualUpdate={updateFileUp}
        inactivateReport={handleInactivate}
        userIsSupport={claimsUser?.is_support}
      />,
    });
  };

  /**
   * Opens an alert showing the inactive report information
   * @param {object} report report info
   * @param {boolean} isDeleted marks if the report has `deletedAt` field
   * @param {function} fetchUpdate updates the list after request
   */
  const openInactiveReportStatus = async (report, isDeleted, fetchUpdate) => {
    /**
     * Handles activation of a report
     */
    const handleActivate = async () => {
      const handleActivateSubmit = async () => {
        const res = await instanceAPI.activateReport(report.id);
        if (res.error) {
          setAlertConfig({
            type: 'error',
            text: res.msg,
            child: res.raw,
          });
          return;
        }
        setAlertConfig({
          type: 'success',
          text: `Relatório ${report.filename} reativado com sucesso!`,
        });
        fetchUpdate();
      };
      setAlertConfig({
        type: 'warning',
        text: `Tem certeza que deseja reativar o relatório ${report.filename}?`,
        withoutConfirm: true,
        withFunction: true,
        confirmFunction: handleActivateSubmit,
      });
    };

    /**
     * Handles restauration of a report
     */
    const handleRestore = async () => {
      const handleRestoreSubmit = async () => {
        const res = await instanceAPI.restoreReport(report.id);
        if (res.error) {
          setAlertConfig({
            type: 'error',
            text: res.msg,
            child: res.raw,
          });
          return;
        }
        setAlertConfig({
          type: 'success',
          text: `Relatório ${report.filename} restaurado com sucesso!`,
        });
        fetchUpdate();
      };
      setAlertConfig({
        type: 'warning',
        text: `Tem certeza que deseja restaurar o relatório ${report.filename}?`,
        withoutConfirm: true,
        withFunction: true,
        confirmFunction: handleRestoreSubmit,
      });
    };

    setAlertConfig({
      type: 'warning',
      text: isDeleted ? 'Relatório removido!' : 'Relatório inativo!',
      child: <FileReportInactive
        reportInfo={report}
        activateReport={handleActivate}
        restoreReport={handleRestore}
      />,
    });
  };

  useEffect(() => {
    (async () => {
      if (isMounted.current) return;
      instanceAPI.getInstances();
    })();
  }, [instanceAPI]);

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  // ### Função para um usuário isAdmin = true adicionar um usuário em uma instância de cliente
  const handleAddUser = async (instance) => {
    const actionLabel = !instance.loginProvider?.length > 0 ? 'Adiciona' : 'Provisiona';
    const users = await handleGetInstanceUser(instance);

    const res = {
      supers: [],
      scientists: [],
      guests: [],
    };

    const count = {
      super: 0,
      scientist: 0,
      guest: 0,
    };

    const getInfo = (item) => {
      switch (item.role) {
        case 'super':
          res.supers.push({ id: item.uid, label: item.email, value: item.email });
          count.super += 1;
          break;
        case 'scientist':
          res.scientists.push({ id: item.uid, label: item.email, value: item.email });
          count.scientist += 1;
          break;
        case 'guest':
          res.guests.push({ id: item.uid, label: item.email, value: item.email });
          count.guest += 1;
          break;
        default:
          break;
      }
    };

    users.forEach((u) => getInfo(u));

    const submitAddUser = async (userInfo) => {
      if (!checkLimits(instance, count, userInfo.role)) return;
      const { error, msg, raw } = await instanceAPI.addUser(
        instance.id, userInfo.scientist, userInfo.email, userInfo.role, userInfo.sendEmail,
      );

      if (error) {
        setAlertConfig({
          type: 'error',
          text: msg,
          child: raw,
        });
        instanceAPI.getInstanceUsers(instance.id);
        toggleModal();
        return;
      }

      setAlertConfig({
        type: 'success',
        text: `Usuário ${actionLabel.toLowerCase()}do com sucesso!`,
        okFunction: () => {
          instanceAPI.getInstanceUsers(instance.id);
          toggleModal();
        },
      });
    };

    setModalConfig({
      title: `${actionLabel}r Novo Usuário`,
      className: 'newUser_modal',
      children: (
        <AddUser
          user={user}
          userIsAdmin={claimsUser?.is_admin}
          usersEmails={[
            ...res.supers.map((u) => u.value),
            ...res.scientists.map((u) => u.value),
            ...res.guests.map((u) => u.value),
          ]}
          scientistEmails={[...res.supers, ...res.scientists]}
          hide={() => {
            toggleModal();
          }}
          fromAdmin
          submitData={submitAddUser}
        />
      ),
    });
  };

  const handleAddAntecipei = async (instance) => {
    const resGetUsers = await instanceAPI.getInstanceUsers(instance.id);
    if (resGetUsers.error) {
      setAlertConfig({
        type: 'error',
        text: resGetUsers.msg,
        child: resGetUsers.raw,
      });
      toggleModal();
      return;
    }
    const users = resGetUsers.users.filter((u) => u.role !== 'guest');

    const submitAntecipei = async (
      filename,
      ownerId,
      url,
      sendWithoutDataProc,
      prettyColumns,
      reportToken,
      onlyActive,
    ) => {
      const { error, msg, raw } = await instanceAPI.addAntecipeiReport(
        filename,
        ownerId,
        instance.id,
        url,
        sendWithoutDataProc,
        prettyColumns,
        reportToken,
        onlyActive,
      );

      if (error) {
        setAlertConfig({
          type: 'error',
          text: msg,
          child: raw,
        });
        toggleModal();
        return;
      }

      setAlertConfig({
        type: 'success',
        text: 'Relatório Antecipei criado com sucesso!',
        okFunction: () => {
          toggleModal();
        },
      });
    };

    setModalConfig({
      title: 'Criar Relatório Antecipei',
      children: (
        <AddAntecipei
          users={users.map((u) => ({
            id: u.uid,
            label: u.email,
            value: u.email,
          }))}
          hide={() => {
            toggleModal();
          }}
          submitData={submitAntecipei}
        />
      ),
    });
  };

  const handleAddBenner = async (instance) => {
    const resGetUsers = await instanceAPI.getInstanceUsers(instance.id);
    if (resGetUsers.error) {
      setAlertConfig({
        type: 'error',
        text: resGetUsers.msg,
        child: resGetUsers.raw,
      });
      toggleModal();
      return;
    }
    const users = resGetUsers.users.filter((u) => u.role !== 'guest');

    const submitBenner = async (
      filename,
      ownerId,
      url,
      username,
      password,
    ) => {
      const { error, msg, raw } = await instanceAPI.addBennerReport(
        filename,
        ownerId,
        instance.id,
        url,
        username,
        password,
      );

      if (error) {
        setAlertConfig({
          type: 'error',
          text: msg,
          child: raw,
        });
        toggleModal();
        return;
      }

      setAlertConfig({
        type: 'success',
        text: 'Relatório Benner criado com sucesso!',
        okFunction: () => {
          toggleModal();
        },
      });
    };

    setModalConfig({
      title: 'Criar Relatório Benner',
      children: (
        <AddBenner
          users={users.map((u) => ({
            id: u.uid,
            label: u.email,
            value: u.email,
          }))}
          hide={() => {
            toggleModal();
          }}
          submitData={submitBenner}
        />
      ),
    });
  };

  const handleOnboarding = async (instance) => {
    const resGetUsers = await instanceAPI.getInstanceUsers(instance.id);
    if (resGetUsers.error) {
      setAlertConfig({
        type: 'error',
        text: resGetUsers.msg,
        child: resGetUsers.raw,
      });
      toggleModal();
      return;
    }
    const users = resGetUsers.users.filter((u) => u.role !== 'guest');

    // Getting users from instance
    const resData = await instanceAPI.getDataExtractorInfo(instance.id);
    if (resData.error) {
      setAlertConfig({
        type: 'error',
        text: resData.msg,
        child: resData.raw,
      });
      toggleModal();
      return;
    }
    const { possibleReports, schemaTypes } = resData.res;

    // Getting modules from database
    const data = await instanceAPI.getDataExtractorModules();
    if (data.error) {
      setAlertConfig({
        type: 'error',
        text: data.msg,
        child: data.raw,
      });
      toggleModal();
      return;
    }
    const l1Modules = possibleReports.name === 'QueryCorporateBrazil'
      ? data.res.corporateModules : data.res.firmsModules;
    const l1ModulesIds = l1Modules.map((mod) => mod.id);

    const modules = possibleReports.fields.filter((f) => {
      if (l1ModulesIds.includes(f.name)) {
        return f;
      }
      return null;
    });

    const fullModules = modules.map((module) => (
      {
        ...module,
        id: module.name,
        label: l1Modules.find((mod) => mod.id === module.name).label,
        value: module.name,
      }
    ));

    const plan = possibleReports.name === 'QueryCorporateBrazil' ? 'Corporate' : 'Firms';

    const getModuleFields = async (module, clientPlan) => {
      const fields = await instanceAPI.getL1ReportModuleFields(module, clientPlan);
      if (fields.error) {
        setAlertConfig({
          type: 'error',
          text: fields.msg,
          child: fields.raw,
        });
        toggleModal();
      }
      return fields?.res;
    };

    const getTemplates = async (module, clientPlan) => {
      const templates = await instanceAPI.getExtractorPossibleTemplates(module, clientPlan);
      if (templates.error) {
        setAlertConfig({
          type: 'error',
          text: templates.msg,
          child: templates.raw,
        });
        toggleModal();
      }
      return templates?.res;
    };

    const submitOnbardingReport = async (
      filename,
      ownerId,
      fields,
      selectedFields,
      module,
      alias,
    ) => {
      const { error, msg, raw } = await instanceAPI.createOnboardingReport(
        filename, instance.id, ownerId, fields, selectedFields, module, alias,
      );

      if (error) {
        setAlertConfig({
          type: 'error',
          text: msg,
          child: raw,
        });
        toggleModal();
        return;
      }

      setAlertConfig({
        type: 'success',
        text: 'Relatório de onboarding adicionado com sucesso!',
        okFunction: () => {
          filesAPI.getFilesList();
          toggleModal();
        },
      });
    };

    setModalConfig({
      title: 'Criar Relatório de Onboarding',
      children: (
        <OnboardingReport
          users={users.map((u) => ({
            id: u.uid,
            label: u.email,
            value: u.email,
          }))}
          modules={fullModules}
          schema={schemaTypes.map((s) => ({
            id: s.name,
            label: s.name,
            value: s.name,
            ...s,
          }))}
          hide={() => toggleModal()}
          submitData={submitOnbardingReport}
          getL1ReportModuleFields={getModuleFields}
          plan={plan}
          getTemplates={getTemplates}
        />
      ),
    });
  };

  const handleRequestApiCredentials = async (instance) => {
    const { error, msg, raw } = await instanceAPI.requestApiCredentials(
      instance.id,
    );

    if (error) {
      setAlertConfig({
        type: 'error',
        text: msg,
        child: raw,
      });
      toggleModal();
      return;
    }

    setAlertConfig({
      type: 'success',
      text: 'Requisição enviada com sucesso!',
      child: 'O e-mail com as requisições foi enviado. Aguarde o cadastro das credenciais para que você possa utilizar a API!',
      okFunction: () => {
        toggleModal();
      },
    });
  };

  const openReportColumns = async (report, fetchUpdate) => {
    const submit = async (columns) => {
      if (columns.length > 0) {
        const res = await instanceAPI.editReportColumns(report.id, columns);
        if (res.error) {
          setAlertConfig({
            type: 'error',
            text: res.msg,
            child: res.raw,
          });
          return;
        }
        setAlertConfig({
          type: 'success',
          text: `Colunas do relatório ${report.filename} alteradas com sucesso!`,
        });
        fetchUpdate();
        closeModal();
      }
    };

    const res = await instanceAPI.getReportColumns(report.id);
    if (res.error) {
      setAlertConfig({
        type: 'error',
        text: res.msg,
        child: res.raw,
      });
      return;
    }

    const handleDecision = (columns) => {
      if (columns.length !== 0) {
        const columnsNames = columns.map((col) => col.src);
        const columnsDependencies = Object.keys(res?.kpis)
          .filter((key) => columnsNames.includes(key));
        const allKpis = columnsDependencies.flatMap((key) => res?.kpis[key]);
        const seen = new Set();
        const uniqueKpis = allKpis.filter((kpi) => {
          if (seen.has(kpi.id)) return false;
          seen.add(kpi.id);
          return true;
        });
        setAlertConfig({
          type: 'warning',
          text: 'Tem certeza que deseja salvar as alterações?',
          child: <ListKpisDependenciesFromColumns kpis={uniqueKpis} file={report} />,
          withoutConfirm: true,
          withFunction: true,
          confirmFunction: () => submit(columns),
        });
      }
      closeModal();
    };

    setModalConfig({
      title: 'Colunas Originais',
      children: (
        <ReportColumns
          columns={res.columns}
          custom={res.custom}
          kpis={res?.kpis || {}}
          hide={toggleModal}
          submitColumns={handleDecision}
        />
      ),
    });
  };

  const openManageCustomColumns = async (reportId, {
    columns, custom, editCColumn, submit, mode,
  }) => {
    const genPreview = async (newColumns) => {
      const res = await instanceAPI.previewCustomColumns(reportId, newColumns);
      if (res.error) {
        setAlertConfig({
          type: 'error',
          text: res.msg,
          child: res.raw,
        });
        return null;
      }
      return res.res;
    };

    const getColumnUnique = async (column, dFormat) => {
      if (!Object.hasOwn(columns, column)) {
        setAlertConfig({
          type: 'error',
          text: 'Coluna selecionada inválida',
          child: 'A coluna selecionada ainda não foi adicionada ao arquivo. Por favor, salve antes de tentar utilizá-la.',
        });
        return [];
      }
      const dateFormat = (dFormat?.value || dFormat) ?? '';
      const uniqueRes = await instanceAPI.getUnique(reportId, column.value ?? column, dateFormat);
      if (uniqueRes.error) {
        setAlertConfig({ type: 'error', text: uniqueRes.msg, child: uniqueRes.raw });
        return [];
      }
      return uniqueRes.res.map((val) => ({ label: val, value: val, id: val }));
    };

    const hide = () => toggleModal('manage-custom-columns');

    if (mode === 'FORMULA') {
      setModalConfig({
        title: 'Colunas Customizadas',
        nodeTarget: 'manage-custom-columns',
        children: (
          <FormulaCustomColumns
            columns={columns}
            custom={custom}
            editCustom={editCColumn}
            genPreview={genPreview}
            submit={submit}
            hide={hide}
          />
        ),
      });
    } else {
      setModalConfig({
        title: 'Colunas Customizadas',
        nodeTarget: 'manage-custom-columns',
        children: (
          <MapCustomColumns
            columns={columns}
            custom={custom}
            editCustom={editCColumn}
            genPreview={genPreview}
            getUnique={getColumnUnique}
            submit={submit}
            hide={hide}
          />
        ),
      });
    }
  };

  const openCustomColumns = async (report, fetchUpdate) => {
    const hide = (skipWarning = false) => {
      if (skipWarning) toggleModal('list-custom-columns');
      else {
        setAlertConfig({
          nodeTarget: 'warning-custom-columns',
          type: 'warning',
          text: 'Tem certeza?',
          child: 'Todas as modificações não salvas serão perdidas.',
          withFunction: true,
          withoutConfirm: true,
          confirmFunction: () => toggleModal('list-custom-columns'),
        });
      }
    };

    const submit = async (newColumns, callback) => {
      if (newColumns.length > 0) {
        const res = await instanceAPI.manageCustomColumns(report.id, newColumns);
        if (res.error) {
          setAlertConfig({
            type: 'error',
            text: res.msg,
            child: res.raw,
          });
          return;
        }
        setAlertConfig({
          type: 'success',
          text: `Relatório ${report.filename} alterado com sucesso!`,
        });
        fetchUpdate();
        callback();
      }
    };

    const handleDecision = (newColumns, callback) => {
      setAlertConfig({
        type: 'warning',
        text: 'Tem certeza que deseja salvar as alterações?',
        withoutConfirm: true,
        withFunction: true,
        confirmFunction: () => submit(newColumns, callback),
      });
    };

    const res = await instanceAPI.getReportColumns(report.id);
    if (res.error) {
      setAlertConfig({
        type: 'error',
        text: res.msg,
        child: res.raw,
      });
      return;
    }

    const handleManageCustomColumns = (info) => openManageCustomColumns(report.id, info);

    setModalConfig({
      title: 'Colunas Customizadas',
      nodeTarget: 'list-custom-columns',
      closeFunc: hide,
      children: (
        <CustomColumns
          columns={res.columns}
          custom={res.custom ?? []}
          manageCustomColumns={handleManageCustomColumns}
          hide={hide}
          submit={handleDecision}
        />
      ),
    });
  };

  const handleGetUserHistory = async (userObj) => {
    const res = await instanceAPI.getUserLoginHistory(userObj.user_id);
    if (res.error) {
      setAlertConfig({
        type: 'error',
        text: res.msg,
        child: res.raw,
      });
      return null;
    }

    setModalConfig({
      title: 'Histórico de Acessos',
      yesLabel: 'Ok',
      children: (
        <UserHistory
          user={userObj}
          history={res.res}
        />
      ),
    });
    return null;
  };

  const handleGetUserInfo = async (userObj) => {
    const res = await instanceAPI.getUserInfo(userObj.email);
    if (res.error) {
      setAlertConfig({
        type: 'error',
        text: res.msg,
        child: res.raw,
      });
      return null;
    }
    setModalConfig({
      title: 'Informações do usuário',
      yesLabel: 'Ok',
      children: (
        <UserInfo
          user={res.res}
          device={device}
        />
      ),
    });
    return null;
  };

  const handleGetUsersDashboards = async (userObj, users) => {
    const res = await instanceAPI.getUserDashboards(userObj.user_id);
    if (res.error) {
      setAlertConfig({
        type: 'error',
        text: res.msg,
        child: res.raw,
      });
      return null;
    }

    const getDashSharedUsers = (dash) => {
      const getShared = () => {
        const usersId = Object.keys(dash.sharedWith);
        const sharedUsers = usersId.map((userId) => {
          const aux = users.find((u) => u.user_id === userId);
          return ({
            ...dash.sharedWith[userId],
            ...aux,
          });
        });
        return sharedUsers;
      };
      const shared = dash?.sharedWith ? getShared() : [];
      const hideShared = () => toggleModal('dash-shared-with');
      setModalConfig({
        title: 'Usuários Compartilhados',
        nodeTarget: 'dash-shared-with',
        yesLabel: 'Ok',
        yesFunc: hideShared,
        children: (
          <DashSharedWith
            dash={dash}
            users={shared}
          />
        ),
      });
    };

    const getDashDependencies = async (dash) => {
      const files = await instanceAPI.getUserDashFiles(
        userObj?.company?.id, userObj?.user_id, dash?.dashId,
      );
      if (files.error) {
        setAlertConfig({
          type: 'error',
          text: files.msg,
          child: files.raw,
        });
        return null;
      }
      const dashDependencies = files.res.map((dashFile) => (
        { ...dashFile, created_at: dashFile.createdAt, updated_at: dashFile.updatedAt }));
      const hideDependencies = () => toggleModal('dash-dependencies');
      setModalConfig({
        title: 'Arquivos Utilizados',
        nodeTarget: 'dash-dependencies',
        yesLabel: 'Ok',
        yesFunc: hideDependencies,
        children: (
          <DashboardDependencies
            dashboard={dash}
            files={dashDependencies}
            users={users}
            deviceType={device}
            adminAccess
          />
        ),
      });
      return null;
    };

    const getDashKpis = async (dash) => {
      const kpisList = await instanceAPI.getDashKpis(userObj?.user_id, dash?.dashId);
      if (kpisList.error) {
        setAlertConfig({
          type: 'error',
          text: kpisList.msg,
          child: kpisList.raw,
        });
        return null;
      }
      const hideDashKpis = () => toggleModal('dash-kpis-list');
      setModalConfig({
        title: 'Lista de KPIs',
        nodeTarget: 'dash-kpis-list',
        yesLabel: 'Ok',
        yesFunc: hideDashKpis,
        children: (
          <DashboardKpisList
            dashboard={dash}
            kpis={kpisList.res}
          />
        ),
      });
      return null;
    };

    const handleDeleteDashboard = (dash) => {
      const handler = async (f) => {
        const deleteResult = await instanceAPI.deleteDashboard(userObj?.user_id, dash?.dashId);
        if (deleteResult.error) {
          setAlertConfig({
            type: 'error',
            text: deleteResult.msg,
            child: `${deleteResult.raw}`,
          });
          return;
        }
        setAlertConfig({
          type: 'success',
          text: `Dashboard ${dash?.name} removido com sucesso!`,
        });
        f();
      };

      const modalHandler = (f) => {
        setAlertConfig({
          type: 'warning',
          text: `Deseja apagar o Dashboard "${dash?.name}"?`,
          withoutConfirm: true,
          withFunction: true,
          confirmFunction: f,
        });
      };

      return { handler, modalHandler };
    };

    setModalConfig({
      title: 'Dashboards do usuário',
      yesLabel: 'Ok',
      children: (
        <UserDashboards
          user={userObj}
          dashboards={res.res}
          getDashSharedUsers={getDashSharedUsers}
          getDashDependencies={getDashDependencies}
          getKpiList={getDashKpis}
          handleDelete={handleDeleteDashboard}
          userIsAdmin={claimsUser?.is_admin}
        />
      ),
    });
    return null;
  };

  const handleMessageUsers = async () => {
    let allUsers = instanceState?.users ?? [];
    if (!allUsers?.length > 0) {
      const res = await instanceAPI.getUsers();
      if (res.error) {
        setAlertConfig({
          type: 'error',
          text: res.msg,
          child: res.raw,
        });
        return;
      }
      allUsers = res.users;
    }
    if (!instanceState.instances) return;
    const plansFromInstances = instanceState.instances.reduce((aux, instance) => {
      if (instance.disabled || instance?.operationalStatus === 'Cancelado') return aux;
      const inst = {
        ...instance,
        label: instance.name,
        value: instance.id,
        key: instance.id,
        planLabel: plans[instance.plan]?.label ?? '',
      };
      if (aux[inst.plan]) aux[inst.plan].push(inst);
      // eslint-disable-next-line no-param-reassign
      else aux[inst.plan] = [inst];
      return aux;
    }, {});
    // const filteredInstances = instanceState.instances.reduce((aux, instance) => {
    //   const inst = {
    //     ...instance,
    //     label: instance.name,
    //     value: instance.id,
    //     key: instance.id,
    //   };
    //   switch (inst.plan) {
    //     case 'advanced':
    //       aux.advanced.push(inst);
    //       break;
    //     case 'standard':
    //       aux.standard.push(inst);
    //       break;
    //     case 'premium':
    //       aux.premium.push(inst);
    //       break;
    //     default:
    //       aux.others.push(inst);
    //       break;
    //   }
    //   return aux;
    // }, {
    //   advanced: [], standard: [], premium: [], others: [],
    // });

    const handleSubmit = async (lvl, title, showUntil, link, selectedInstances, message) => {
      try {
        const res = await instanceAPI.sendMultiInstanceUsersMessage(
          selectedInstances, lvl, title, showUntil, link, allUsers, message,
        );
        if (res?.error) {
          setAlertConfig({
            type: 'error',
            text: res?.msg,
            child: res?.raw,
          });
          return;
        }
        setAlertConfig({
          type: 'success',
          text: 'Mensagem enviada aos clientes selecionados!',
        });
        closeModal();
      } catch (error) {
        setAlertConfig({
          type: 'error',
          text: error.message,
        });
      }
    };
    if (Object.keys(plansFromInstances).length > 0) {
      setModalConfig({
        title: 'Nova Mensagem',
        disableFocus: true,
        children: (
          <MultiMessages
            hide={closeModal}
            submit={handleSubmit}
            plans={plansFromInstances}
          />
        ),
      });
    } else {
      setAlertConfig({
        type: 'warning',
        text: 'Instâncias não encontradas!',
      });
    }
  };

  const handleApiGedRegister = async (instance, editting = false) => {
    const submit = async (key, secret) => {
      const res = await instanceAPI.saveGedCredentials(
        instance.id, key, secret, editting ? 'edit' : 'create', user,
      );
      if (res.error) {
        setAlertConfig({
          type: 'error',
          text: res.msg,
          child: res.raw,
        });
        return;
      }
      setAlertConfig({
        type: 'success',
        text: `Credencial GED ${editting ? 'atualizada' : 'cadastrada'} com sucesso!`,
      });
      closeModal();
    };

    setModalConfig({
      title: 'Cadastro da API GED',
      children: (
        <RegisterApiGedCredentials
          submit={submit}
          hide={closeModal}
          editting={editting}
        />
      ),
    });
  };

  const handleAllowL1Reports = async (instance) => {
    const instanceHasAdminPermission = !!instance?.l1reportActive;
    const instanceHasSupportPermission = !!instance?.supportPermissionReports;

    const submit = async (userInfo, validUntil) => {
      if (instanceHasAdminPermission) {
        closeModal();
        return;
      }
      const res = await instanceAPI.saveSupportPermissions(
        instance.id, userInfo, validUntil,
      );
      if (res.error) {
        setAlertConfig({
          type: 'error',
          text: res.msg,
          child: res.raw,
        });
        return;
      }
      setAlertConfig({
        type: 'success',
        text: 'Permissão para criação de relatórios Legal One concedida com sucesso!',
      });
      closeModal();
    };

    setModalConfig({
      title: 'Permissão de criação de relatórios Legal One',
      children: (
        <AllowL1ReportsBySupport
          submit={submit}
          hide={closeModal}
          user={user}
          instanceHasAdminPermission={instanceHasAdminPermission}
          instanceHasSupportPermission={instanceHasSupportPermission}
          supportPermissionExpiration={instance?.supportPermissionReportsExpiration || ''}
        />
      ),
    });
  };

  const handleCreateETL = async (report, etl, dryRun, update = false, autoUpdated = false) => {
    const res = await instanceAPI.createETL(report, etl, dryRun, update, autoUpdated);
    if (res.error) {
      setAlertConfig({
        type: 'error',
        text: res.msg,
        child: res.raw,
      });
      return;
    }
    setAlertConfig({
      type: 'success',
      text: `ETL ${dryRun ? 'executado' : 'criado'} com sucesso!`,
    });
  };

  const handleDownload = async (report) => {
    const etl = {
      label: 'Baixar relatório',
      value: 'create',
      id: 'create',
      name: '',
      description: '',
      order: 0,
      code: '',
      required_report_ids: [],
    };
    const res = await instanceAPI.createETL(report, etl, true, false, false);
    if (res.error) {
      setAlertConfig({
        type: 'error',
        text: res.msg,
        child: res.raw,
      });
      return;
    }
    setAlertConfig({
      type: 'success',
      text: 'Relatório baixado com sucesso',
    });
  };

  const handleUpdateETL = async (report, etl, dryRun, update = false, autoUpdated = false) => {
    const res = await instanceAPI.updateETL(report, etl, dryRun, update, autoUpdated);
    if (res.error) {
      setAlertConfig({
        type: 'error',
        text: res.msg,
        child: res.raw,
      });
      return;
    }
    setAlertConfig({
      type: 'success',
      text: `ETL ${dryRun ? 'executado' : 'atualizado'} com sucesso!`,
    });
  };
  const handleDeleteETL = (reportDoc, etlDoc) => {
    const handler = async (f) => {
      const deleteResult = await instanceAPI.deleteETL(reportDoc, etlDoc);
      if (deleteResult.error) {
        setAlertConfig({
          type: 'error',
          text: deleteResult.msg,
          child: `${deleteResult.raw}`,
        });
        return;
      }
      setAlertConfig({
        type: 'success',
        text: `ETL "${etlDoc?.name || etlDoc?.description || etlDoc?.id}" removido com sucesso!`,
      });
      f();
    };

    const modalHandler = (f) => {
      setAlertConfig({
        type: 'warning',
        text: `Deseja apagar o ETL "${etlDoc?.name || etlDoc?.description || etlDoc?.id}"?`,
        withoutConfirm: true,
        withFunction: true,
        confirmFunction: f,
      });
    };

    return { handler, modalHandler };
  };
  const fetchReportETLs = async (report) => {
    const res = await instanceAPI.getReportETLs(report.id);
    if (res.error) {
      setAlertConfig({
        type: 'error',
        text: res.msg,
        child: res.raw,
      });
    }
    return res.data;
  };
  const openReportETLs = async (report, companyReports) => {
    const data = await fetchReportETLs(report);
    setModalConfig({
      title: `ETLs do Relatório ${report.filename}`,
      children: (
        <ReportETLs
          etls={data}
          hide={closeModal}
          reportDoc={report}
          companyReports={companyReports}
          createETL={handleCreateETL}
          updateETL={handleUpdateETL}
          fetchReportETLs={fetchReportETLs}
          handleDelete={handleDeleteETL}
        />
      ),
    });
  };

  const convertToGed = async (report, fetchUpdate) => {
    const handleConvertToGed = async () => {
      const res = await instanceAPI.convertToGed(report.id);
      if (res.error) {
        setAlertConfig({
          type: 'error',
          text: res.msg,
          child: res.raw,
        });
        return;
      }
      setAlertConfig({
        type: 'success',
        text: `Relatório ${report.filename} convertido com sucesso!`,
      });
      fetchUpdate();
    };

    if (report.connector !== 'mail') {
      setAlertConfig({
        type: 'error',
        text: 'Você só pode converter relatórios configurados como e-mail para a API GED.',
      });
      return;
    }
    setAlertConfig({
      type: 'warning',
      text: `Tem certeza que deseja converter o relatório ${report.filename} utilizando a API GED?`,
      withoutConfirm: true,
      withFunction: true,
      confirmFunction: handleConvertToGed,
    });
  };

  const handleResetReportAttempts = async (report, fetchUpdate) => {
    const handleReset = async () => {
      const res = await instanceAPI.resetReportAttempts(report.id);
      if (res.error) {
        setAlertConfig({
          type: 'error',
          text: res.msg,
          child: res.raw,
        });
        return;
      }
      setAlertConfig({
        type: 'success',
        text: `Tentativas do relatório ${report.filename} resetadas com sucesso!`,
      });
      fetchUpdate();
    };

    setAlertConfig({
      type: 'warning',
      text: `Tem certeza que deseja resetar as tentativas do relatório ${report.filename}?`,
      withoutConfirm: true,
      withFunction: true,
      confirmFunction: handleReset,
    });
  };

  const listOfInstancesToShow = (list) => {
    const instancesToShowToSupport = [
      'Operacional',
      'Preparado',
      'Prospecto',
      'Em implantação',
      'Em espera',
    ];
    if (!claimsUser?.is_admin && claimsUser?.is_support) {
      return list.filter((instance) => instancesToShowToSupport.includes(
        instance?.operationalStatus,
      ));
    }
    return list;
  };

  const handleDeactivateCustomerReports = async (instance) => {
    const handleReset = async () => {
      const res = await instanceAPI.inactivateReportsFromCompany(instance.id);
      if (res.error) {
        setAlertConfig({
          type: 'error',
          text: res.msg,
          child: res.raw,
        });
        return;
      }
      setAlertConfig({
        type: 'success',
        text: `Relatórios do cliente "${instance.name}" inativados com sucesso!`,
      });
      fetchReports(0, {}, 25);
    };
    setAlertConfig({
      type: 'warning',
      text: `Tem certeza que deseja inativar os relatórios do cliente "${instance.name}?"`,
      withoutConfirm: true,
      withFunction: true,
      confirmFunction: handleReset,
    });
  };

  const handleReactivateCustomerReports = async (instance) => {
    const handleReset = async () => {
      const res = await instanceAPI.activateReportsFromCompany(instance.id);
      if (res.error) {
        setAlertConfig({
          type: 'error',
          text: res.msg,
          child: res.raw,
        });
        return;
      }
      setAlertConfig({
        type: 'success',
        text: `Relatórios do cliente "${instance.name}" reativados com sucesso!`,
      });
      fetchReports(0, {}, 25);
    };

    setAlertConfig({
      type: 'warning',
      text: `Tem certeza que deseja reativar os relatórios inativos do cliente "${instance.name}"?`,
      withoutConfirm: true,
      withFunction: true,
      confirmFunction: handleReset,
    });
  };

  const handleChangeBennerCredentials = async (report) => {
    const changeBennerCredentials = async (password, url, username) => {
      const result = await instanceAPI.changeBennerCredentials(report.id, password, url, username);
      if (result.error) {
        setAlertConfig({
          type: 'error',
          text: result.msg,
          child: result.raw,
        });
        return;
      }
      setAlertConfig({
        type: 'success',
        text: 'Senha atualizada com sucesso!',
      });
      closeModal();
    };

    const reportInfo = await instanceAPI.getReportStatus(report.id);
    const reportConfig = reportInfo.data?.validation?.config;

    const username = reportConfig?.auth?.username ?? null;
    const password = reportConfig?.auth?.password ?? '';
    const url = reportConfig?.url ?? null;

    setModalConfig({
      title: 'Alterar Credenciais do Relatório',
      className: 'changeDatabasePasswordModal',
      children: (
        <ChangeDatabasePassword
          close={closeModal}
          submit={changeBennerCredentials}
          credentialUsername={username}
          credentialPassword={password}
          credentialUrl={url}
        />
      ),
    });
  };

  const handleRemovePasswords = async (instance) => {
    const handlePassRemoval = async () => {
      const res = await instanceAPI.removePasswordsFromCompany(instance.id);
      if (res.error) {
        setAlertConfig({
          type: 'error',
          text: res.msg,
          child: res.raw,
        });
        return;
      }
      setAlertConfig({
        type: 'success',
        text: `Senhas dos usuários do cliente "${instance.name}" removidas com sucesso!`,
      });
    };

    setAlertConfig({
      type: 'warning',
      text: `Tem certeza que deseja forçar o uso de SSO para o cliente "${instance.name}"?`,
      child: 'As senhas dos usuários serão removidas',
      withoutConfirm: true,
      withFunction: true,
      confirmFunction: handlePassRemoval,
    });
  };

  return (
    <>
      {(instanceState.isLoading) && <Loader />}
      <AdminToolbar
        tab={tab}
        setTab={setTab}
        handleNewInstance={handleNewInstance}
        setFilterText={handleText}
        handleMessage={handleMessageUsers}
        //
        userIsAdmin={claimsUser?.is_admin}
      />
      {tab === 'customers' && (
        <InstanceTable
          instances={listOfInstancesToShow(instanceState.instances)}
          openUsersModal={openUsersModal}
          handleInformation={handleInformation}
          //
          handleEdit={handleEditInstance}
          handleAddTokens={handleAddTokens}
          handleBlock={handleBlockInstance}
          handleDelete={handleDeleteInstance}
          handleAddUser={handleAddUser}
          handleAddAntecipei={handleAddAntecipei}
          handleAddBenner={handleAddBenner}
          handleOnboarding={handleOnboarding}
          handleRequestApiCredentials={handleRequestApiCredentials}
          handleMessage={handleMessageInstance}
          handleApiGedRegister={handleApiGedRegister}
          handleAllowL1Reports={handleAllowL1Reports}
          handleRemovePasswords={handleRemovePasswords}
          //
          userIsAdmin={claimsUser?.is_admin}
          userIsSupport={claimsUser?.is_support}
          plans={plans}
          //
          filterText={filterText}
          handleDeactivateCustomerReports={handleDeactivateCustomerReports}
          handleReactivateCustomerReports={handleReactivateCustomerReports}
        />
      )}
      {tab === 'reports' && (
        <ReportsTable
          reports={instanceState.reports}
          instances={listOfInstancesToShow(instanceState.instances)}
          //
          getReports={fetchReports}
          openReportETLs={openReportETLs}
          deleteReport={handleDeleteReport}
          resetReport={handleResetReport}
          changeReportOwner={handleChangeReportOwner}
          openReportStatus={openReportStatus}
          openInactiveReportStatus={openInactiveReportStatus}
          openReportColumns={openReportColumns}
          openCustomColumns={openCustomColumns}
          convertToGed={convertToGed}
          handleDownload={handleDownload}
          resetReportAttempts={handleResetReportAttempts}
          changeBennerCredentials={handleChangeBennerCredentials}
          //
          userIsAdmin={claimsUser?.is_admin}
          userIsSupport={claimsUser?.is_support}
        />
      )}
      {tab === 'users' && (
        <UsersTable
          users={instanceState.users}
          getUsers={handleGetUsers}
          getUserInfo={handleGetUserInfo}
          getUserHistory={handleGetUserHistory}
          getUserDashboards={handleGetUsersDashboards}
          filterText={filterText}
          handleDelete={handleDeleteUser}
          handleDeactivate={handleDeactivateUser}
          handleReactivateUser={handleReactivateUser}
          handleGetResetPwdLink={handleGetResetPwdLink}
          handleUserEmail={handleUserEmail}
          userIsAdmin={claimsUser?.is_admin}
          userIsSupport={claimsUser?.is_support}
        />
      )}
    </>
  );
}

/**
 * Fazendo esse HOC, ao invés de usar o InstanceProvider no App,
 * é possível deixar as funções do instanceProvider somente para a página de admin.
 */

const AdminHOC = ({ ...props }) => (
  <InstanceProvider>
    <AdminPage {...props} />
  </InstanceProvider>
);

export default AdminHOC;
